export default "__VITE_ASSET__DTncH3ZW__"